import { render, staticRenderFns } from "./PortfolioYearEndTransitionDecisionDialog.vue?vue&type=template&id=f543668c"
import script from "./PortfolioYearEndTransitionDecisionDialog.vue?vue&type=script&lang=js"
export * from "./PortfolioYearEndTransitionDecisionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports